module.exports = __webpack_public_path__ + "static/AviaryAttorney2-c06b43dddb74fc338875c6d40d5550c5.png";